import React from 'react';
import styled from 'styled-components';
import GeneraTabla from '../components/Tablas';
import Barras from '../components/Barras';
import { addDot } from '../utils/index';
import { useTranslate } from '../contexts/languageContext';
import { useIsDesktop, useIsMobile } from '../hooks/useMediaQuery';

const TablaPartidos = ({ data, nomenclator }) => {
  const t = useTranslate();
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();

if (!data) return (<div>No hay infomación</div>);;
  if (data[0] && data[0].vot.act === '0' || !data[0]) return <SinInfo>{t('sinInformacion')}</SinInfo>;
  return (
    <TablaSpread
      isDesktop={isDesktop}
      caption={<span className="visually-hidden">Tabla del ranking</span>}
      columns={{
        assets: {
          align: ['start'],
          padding: [!isMobile ? 1 : 0.8],
        },
        render: data => [
          <FilaPartido
            isMobile={isMobile}
            nomPar={nomenclator.partidos[Number(data.codpar) - 1].nombre}
            votAct={data.vot.act}
            votAnt={data.vot.ant}
            votAntAnt={data.vot.antant}
            pvotAct={data.pvot.act}
            pvotAnt={data.pvot.ant}
            pvotAntAnt={data.pvot.antant}
          />,
        ],
      }}
      data={data}
      hoverColor={'#eaeaea'}
      oddStripesColor={'#f8f8f7'}
      tbodyRowHeight={'5em'}
      cellTabindex={true}
    />
  );
};

export default TablaPartidos;

const TablaSpread = styled(GeneraTabla)`
  width: ${({ isDesktop }) => (isDesktop ? '98%' : '100%')};
  border-spacing: 0;
  text-transform: uppercase;
  ${({ isDesktop }) => isDesktop && 'margin-top: 2rem'};
  & caption {
    text-align: left;
    line-height: 2em;
  }
`;

const FilaPartido = ({
  isMobile,
  nomPar,
  votAct,
  votAnt,
  votAntAnt,
  pvotAct,
  pvotAnt,
  pvotAntAnt,
}) => {
  return (
    <Celda isMobile={isMobile}>
      <div>{nomPar}</div>
      <WrapDatos isMobile={isMobile}>
        <FilaDato isMobile={isMobile}>
          <div>
            2022: {addDot(votAct)} ({pvotAct})
          </div>
          <Barras
            width={pvotAct.replace(/,/g, '.')}
            fill={'#00B0AC'}
            height={!isMobile ? '10px' : '15px'}
          />
        </FilaDato>
        <FilaDato isMobile={isMobile}>
          <div>
            2018: {addDot(votAnt)} ({pvotAnt})
          </div>
          <Barras
            width={pvotAnt.replace(/,/g, '.')}
            fill={'#768AA4'}
            height={isMobile && '10px'}
          />
        </FilaDato>
        <FilaDato isMobile={isMobile}>
          <div>
            2014: {addDot(votAntAnt)} ({pvotAntAnt})
          </div>
          <Barras
            width={pvotAntAnt.replace(/,/g, '.')}
            fill={'#db979c'}
            height={isMobile && '10px'}
          />
        </FilaDato>
      </WrapDatos>
    </Celda>
  );
};

const Celda = styled.div`
  & > div:first-child {
    color: #283f5f;
    font-weight: 800;
    font-size: ${({ isMobile }) => (!isMobile ? '1.4rem' : '1.3rem')};
  }
`;

const WrapDatos = styled.div`
  font-size: 1.2rem;
  padding-top: 0.4em;
  & > div:first-child {
    font-weight: 900;
    font-size: ${({ isMobile }) => (!isMobile ? '1.4rem' : '1.2rem')};
  }
`;

const FilaDato = styled.div`
  display: flex;
  align-items: center;
  & > div:first-child {
    ${({ isMobile }) =>
      isMobile
        ? 'width: 100%; text-align: right; padding-right: 0.5em;'
        : 'width: 40%;'};
  }
`;

const SinInfo = styled.h4`
  margin-top: 2rem;
  font-size: 1.5rem;
`;
